// Portfolio Administration v1.0 PR 6 — colored status badge used across
// the Waterfalls list, detail header, and version timeline.

import { Badge } from "@/design-system/components/ui";

interface WaterfallStatusBadgeProps {
  status: string;
  className?: string;
}

const STATUS_LABELS: Record<string, string> = {
  draft: "Draft",
  proposed: "Proposed",
  active: "Active",
  superseded: "Superseded",
};

const STATUS_VARIANT: Record<string, "draft" | "review" | "finalized" | "archived"> = {
  draft: "draft",
  proposed: "review",
  active: "finalized",
  superseded: "archived",
};

export function WaterfallStatusBadge({ status, className }: WaterfallStatusBadgeProps) {
  const variant = STATUS_VARIANT[status] ?? "draft";
  const label = STATUS_LABELS[status] ?? status;
  return (
    <Badge
      status={variant}
      className={className}
      data-testid={`waterfall-status-${status}`}
    >
      {label}
    </Badge>
  );
}
